const INTENT_TYPES = Object.freeze({
  DUPLICATE: "duplicate",
  DOB_CHECK: "dob_check",
  CLUSTER: "cluster",
  DUPLICATE_CHECK_BY_CASE_ID: "duplicate_check_by_case_id",
  STATUS_CHECK_BY_CASE_ID: "status_check_by_case_id",
  ELGIBILITY_REVIEW: "eligibility_review",
});

export default INTENT_TYPES;
